import React from "react"
import { Stack } from "@mui/material"
import HoursMaskedField from "../../../components/form/MaskedField"
import FormikErrorMessage from "../../../components/FormikErrorMessage"

const PSEHoursInput = ({
    startTime,
    endTime,
    onChange
}) => {
    if (!startTime && !endTime) {
        return null
    }

    return (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
            {startTime && (
                <Stack sx={{ flex: 1 }}>
                    <HoursMaskedField name={startTime.name} value={startTime.value} onChange={onChange} width="100%"/>

                    {startTime.error && <FormikErrorMessage name={startTime.name} />}
                </Stack>
            )}
            {startTime && endTime && (
                <div>-</div>
            )}
            {endTime && (
                <Stack sx={{ flex: 1 }}>
                <HoursMaskedField name={endTime.name} value={endTime.value} onChange={onChange} width="100%" />
                {endTime.error && <FormikErrorMessage name={endTime.name} />}
            </Stack>
            )}
        </Stack>
    )
}

export default PSEHoursInput